<div class="rcm-wrapper">
  <div class="btn-nav" style="margin-bottom: 60px">
    <ul class="btn-ul">
      <li [class.active]="activeTab == 'today'" class="btn" (click)="todayAlertApi()">Today</li>
      <li [class.active]="activeTab == 'seven'" class="btn" (click)="weekAlertApi()">Last 7</li>
      <li [class.active]="activeTab == 'thirty'" class="btn" (click)="thirtyAlertApi()">Last 30</li>
      <li [class.active]="activeTab == 'month'" class="btn" (click)="picker.open()">
        <div class="month-div">
          <span>Month</span>
          <mat-form-field>
            <input matInput [matDatepicker]="picker" [(ngModel)]="monthDateValue" (ngModelChange)="monthAlertApi()" />
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </li>
      <li [class.active]="activeTab == 'range'" class="btn" (click)="rangeInpShow = !rangeInpShow">Custom</li>
    </ul>
    @if (rangeInpShow) {
      <div class="range-input">
        <mat-form-field appearance="outline">
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate [(ngModel)]="dateRangeValue.startDate" placeholder="Start Date" (dateChange)="dateSelect()">
            <input matEndDate [(ngModel)]="dateRangeValue.endDate" placeholder="End Date" (dateChange)="dateSelect()">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
        </mat-form-field>
        <mat-date-range-picker #rangePicker></mat-date-range-picker>
        <!-- <input *ngIf="rangeInpShow" type="text" ngxDaterangepickerMd [(ngModel)]="dateRangeValue" class="form-control"
        placeholder="Select Range" (ngModelChange)="dateSelect()" /> -->
      </div>
    }
  </div>

  <mat-accordion>

    <!-- GROSS RECEIVED -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Gross Received</mat-panel-title>
        <mat-panel-description>
          <span class="title-price">${{ grossReceivedTotal }}</span>
          <span>({{ grossReceivedResults }})</span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <mat-accordion>
        <!-- ACH -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>ACH</mat-panel-title>
            <mat-panel-description>
              <span class="title-price">${{ achTotalAmount }}</span>
              <span>({{ achTotalResults }})</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <table style="width: 100%" mat-table [dataSource]="achDataSource" matSort #achSort="matSort"
            (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number">Last Name
              </th>
              <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
            </ng-container>
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">
              First Name</th>
              <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
            </ng-container>
            <ng-container matColumnDef="birthday">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by birthday">Birthday
              </th>
              <td mat-cell *matCellDef="let element">{{ element.birthday | date:'MMM d, y' }}</td>
            </ng-container>
            <ng-container matColumnDef="dueDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by dueDate">Due Date
              </th>
              <td mat-cell *matCellDef="let element">{{ element.dueDate | date:'MMM d, y' }}</td>
            </ng-container>
            <ng-container matColumnDef="dateProcessed">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by dateProcessed">Date
              Processed</th>
              <td mat-cell *matCellDef="let element">{{ element.dateProcessed | date:'MMM d, y' }}</td>
            </ng-container>
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by amount">Amount</th>
              <td mat-cell *matCellDef="let element">${{ element.amount }}</td>
            </ng-container>
            <ng-container matColumnDef="dueNow">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by dueNow">Due Now</th>
              <td mat-cell *matCellDef="let element">${{ element.dueNow }}</td>
            </ng-container>
            <ng-container matColumnDef="totalDue">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by totalDue">Total Due
              </th>
              <td mat-cell *matCellDef="let element">${{ element.totalDue }}</td>
            </ng-container>
            <ng-container matColumnDef="pmsTransfer">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by pmsTransfer">PMS
              Transfer</th>
              <td mat-cell *matCellDef="let element">
                <input type="checkbox" class="accordion-checkbox" />
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="acmDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: acmDisplayedColumns"></tr>
          </table>
        </mat-expansion-panel>

        <!-- CREDIT CARDS -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Credit Cards</mat-panel-title>
            <mat-panel-description>
              <span class="title-price">${{ creditCardTotalAmount }}</span>
              <span>({{ creditCardResults }})</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <table style="width: 100%" mat-table [dataSource]="creditCardDataSource" matSort #creditCardSort="matSort"
            (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
              <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
            </ng-container>
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
              <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
            </ng-container>
            <ng-container matColumnDef="birthday">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Birthday</th>
              <td mat-cell *matCellDef="let element">{{ element.birthday | date:'MMM d, y' }}</td>
            </ng-container>
            <ng-container matColumnDef="dueDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Due Date</th>
              <td mat-cell *matCellDef="let element">{{ element.dueDate | date:'MMM d, y' }}</td>
            </ng-container>
            <ng-container matColumnDef="dateProcessed">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Processed</th>
              <td mat-cell *matCellDef="let element">{{ element.dateProcessed | date:'MMM d, y' }}</td>
            </ng-container>
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
              <td mat-cell *matCellDef="let element">${{ element.amount }}</td>
            </ng-container>
            <ng-container matColumnDef="dueNow">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Due Now</th>
              <td mat-cell *matCellDef="let element">${{ element.dueNow }}</td>
            </ng-container>
            <ng-container matColumnDef="totalDue">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Due</th>
              <td mat-cell *matCellDef="let element">${{ element.totalDue }}</td>
            </ng-container>
            <ng-container matColumnDef="pmsTransfer">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>PMS Transfer</th>
              <td mat-cell *matCellDef="let element">
                <input type="checkbox" class="accordion-checkbox" />
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="creditCardDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: creditCardDisplayedColumns"></tr>
          </table>
        </mat-expansion-panel>

        <!-- DEBIT CARDS -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Debit Cards</mat-panel-title>
            <mat-panel-description>
              <span class="title-price">${{ debitCrdTotalAmount }}</span>
              <span>({{ debitCardResults }})</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <table style="width: 100%" mat-table [dataSource]="debitCardDataSource" matSort #debitCardSort="matSort"
            (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
              <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
            </ng-container>
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
              <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
            </ng-container>
            <ng-container matColumnDef="birthday">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Birthday</th>
              <td mat-cell *matCellDef="let element">{{ element.birthday | date:'medium' }}</td>
            </ng-container>
            <ng-container matColumnDef="dueDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Due Date</th>
              <td mat-cell *matCellDef="let element">${{ element.dueDate | date:'medium' }}</td>
            </ng-container>
            <ng-container matColumnDef="dateProcessed">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Processed</th>
              <td mat-cell *matCellDef="let element">${{ element.dateProcessed | date:'medium' }}</td>
            </ng-container>
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
              <td mat-cell *matCellDef="let element">${{ element.amount }}</td>
            </ng-container>
            <ng-container matColumnDef="dueNow">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Due Now</th>
              <td mat-cell *matCellDef="let element">${{ element.dueNow }}</td>
            </ng-container>
            <ng-container matColumnDef="totalDue">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Due</th>
              <td mat-cell *matCellDef="let element">{{ element.totalDue }}</td>
            </ng-container>
            <ng-container matColumnDef="pmsTransfer">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>PMS Transfer</th>
              <td mat-cell *matCellDef="let element">
                <input type="checkbox" class="accordion-checkbox" />
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="debitCardDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: debitCardDisplayedColumns"></tr>
          </table>
        </mat-expansion-panel>
      </mat-accordion>

    </mat-expansion-panel>

    <!-- CONTRACTS NEEDING ACTION -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Contracts Needing Action</mat-panel-title>
        <mat-panel-description>
          <span>({{ contractsNeedingActionResult }})</span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <table style="width: 100%" mat-table [dataSource]="contractNeedingActionPayDataSource" matSort
        #contractNeedingActionSort="matSort" (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
          <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
        </ng-container>
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
          <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
        </ng-container>
        <ng-container matColumnDef="birthday">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Birthday</th>
          <td mat-cell *matCellDef="let element">{{ element.birthday | date:'MMM d, y' }}</td>
        </ng-container>
        <ng-container matColumnDef="contractComplete">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract completed</th>
          <td mat-cell *matCellDef="let element">{{ element.contractComplete | date:'MMM d, y' }}</td>
        </ng-container>
        <ng-container matColumnDef="contractAmt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract Amt</th>
          <td mat-cell *matCellDef="let element">${{ element.contractAmt }}</td>
        </ng-container>
        <ng-container matColumnDef="paymentDue">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Due</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{'text-danger':element.type == 'No Down Payment'}">
          {{ element.dueNow }}</td>
        </ng-container>
        <ng-container matColumnDef="paymentPlanSetup">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Plan Setup</th>
          <td mat-cell *matCellDef="let element" matTooltip="{{element.type}}" class="text-danger">{{
          element.paymentPlanSetup }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="contractNeedingActionDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: contractNeedingActionDisplayedColumns"></tr>
      </table>

    </mat-expansion-panel>

    <!-- FAILED PAYMENTS -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Failed Payments</mat-panel-title>
        <mat-panel-description>
          <span>({{ failedPayResult }})</span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <table style="width: 100%" mat-table [dataSource]="failedPayDataSource" matSort #failedPaySort="matSort"
        (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
          <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
        </ng-container>
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
          <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
        </ng-container>
        <ng-container matColumnDef="birthday">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Birthday</th>
          <td mat-cell *matCellDef="let element">{{ element.birthday | date:'MMM d, y' }}</td>
        </ng-container>
        <ng-container matColumnDef="failDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Fail Date</th>
          <td mat-cell *matCellDef="let element">{{ element.failDate | date:'MMM d, y' }}</td>
        </ng-container>
        <ng-container matColumnDef="paymentAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Amount</th>
          <td mat-cell *matCellDef="let element">${{ element.paymentAmount }}</td>
        </ng-container>
        <ng-container matColumnDef="paymentType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Type</th>
          <td mat-cell *matCellDef="let element">{{ element.paymentType }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="failedPayDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: failedPayDisplayedColumns"></tr>
      </table>
    </mat-expansion-panel>
  </mat-accordion>

</div>
